// Response type from LiveKit token API
export interface LiveKitTokenResponse {
  token: string;
  serverUrl: string;
  roomName: string;
  participantName: string;
  participantIdentity: string;
}

// Function to fetch LiveKit token from Lambda API
export async function fetchLiveKitToken(
  participantToken: string,
  roomName: string,
  participantName: string,
  participantIdentity: string
): Promise<LiveKitTokenResponse> {
  try {
    const response = await fetch(
      "https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api/generate-livekit-token",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          participantToken,
          roomName,
          participantName,
          participantIdentity,
        }),
      }
    );

    if (!response.ok) {
      // Try to extract error message from response
      let errorMessage: string = `Failed to fetch LiveKit token: ${response.status}`;
      try {
        const errorData = await response.json();
        // Check for various error message formats
        const extractedError = errorData.error || errorData.message || errorData.errorMessage;
        if (extractedError) {
          // If error is an object, try to extract message
          if (typeof extractedError === 'object' && extractedError !== null) {
            errorMessage = extractedError.message || extractedError.error || JSON.stringify(extractedError);
          } else if (typeof extractedError === 'string') {
            errorMessage = extractedError;
          }
        }
      } catch (parseError) {
        // If JSON parsing fails, use status text
        errorMessage = response.statusText || errorMessage;
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    
    // Extract token and serverUrl from response
    const token = data.token || data.participantToken || data.accessToken || data.access_token;
    const serverUrl = data.serverUrl || process.env.REACT_APP_LIVEKIT_URL || "wss://your-livekit-server.com";
    
    if (!token) {
      throw new Error("Token not found in API response");
    }
    
    return {
      token,
      serverUrl,
      roomName: data.roomName || roomName,
      participantName: data.participantName || participantName,
      participantIdentity: data.participantIdentity || participantIdentity,
    };
  } catch (error) {
    // Error: "Error fetching LiveKit token:", error);
    throw error;
  }
}

